import { useState } from 'react';
import { useSelector } from 'react-redux';

import { selectControls } from '../../redux/controls';
import AboutModal from '../Modals/AboutModal/AboutModal';
import NQTFooterPanel from './NQTFooterPanel';
import SystemRequirementsModal from '../Modals/SystemRequirementsModal/SystemRequirementsModal';
import AboutNAEPModal from '../Modals/AboutNAEPModal/AboutNAEPModal';
import FAQModal from '../Modals/FAQModal/FAQModal';
import ComingSoonModal from '../Modals/ComingSoonModal/ComingSoonModal';
import TestModal from '../Modals/TestModal/TestModal';
import LoginModal from '../Modals/LoginModal/LoginModal';
import AccountModal from '../Modals/AccountModal/AccountModal';
//import { useNavigate } from 'react-router';

import './NQTFooter.scss';



export const NQTFooter = (): JSX.Element => {
  const controls = useSelector(selectControls);
  // const navigate = useNavigate();

  const [aboutIsOpen, setAboutIsOpen] = useState<boolean>(false);
  const [isTestModalOpen, setIsTestModalOpen] = useState<boolean>(false);
  const [aboutNAEPOpen, setAboutNAEPIsOpen] = useState<boolean>(false);
  const [goToCopyright, setGoToCopyright] = useState<boolean>(false);
  const [frequentlyAskedQuestionsOpen, setFAQIsOpen] = useState<boolean>(false);
  const [systemReqIsOpen, setSystemReqIsOpen] = useState<boolean>(false);
  const [comingSoonIsOpen, setComingSoonIsOpen] = useState<boolean>(false);
  const [loginIsOpen, setLoginIsOpen] = useState<boolean>(false);
  const [accountIsOpen, setAccountIsOpen] = useState<boolean>(false);

  const [accordionOneIsOpen, setAccordionOneIsOpen] = useState<boolean>(false);
  // const [accordionTwoIsOpen, setAccordionTwoIsOpen] = useState<boolean>(false);
  const [accordionThreeIsOpen, setAccordionThreeIsOpen] = useState<boolean>(false);



  return (
    <>
      <section className="nqt-footer">
        <div className="container-fluid nqt-footer-main">
          <div id="nqt-footer--additional-resources">
            <div className='nqt-content-box--top'><h2>{controls?.FooterResourcesHeader?.controlText}</h2>
              <NQTFooterPanel
                title={controls?.NQTFooterSampleInteractiveTasksPanelTitle?.controlText}
                isActive={accordionThreeIsOpen === true}
                onShow={() => { setAccordionThreeIsOpen(!accordionThreeIsOpen); }}>
                <ul>
                  <li><a className="nqt-panel-link" href="https://enaep.cotw-ng.naep.ed.gov/cotw/Grade8/RED/blocks/2217RE2W71CLIT30EX"
                    title={controls?.NQTFooterSampleInteractiveTasksTitle?.controlText} target="_blank" rel="noreferrer">
                    {controls?.NQTFooterSampleInteractiveTasksContent?.controlText}
                  </a></li>
                  <li><a className="nqt-panel-link" href="https://www.nationsreportcard.gov/science/sample-questions/how-seeds-travel/?grade=4"
                    title={controls?.NQTFooterSampleInteractiveTasksTitle?.controlText} target="_blank" rel="noreferrer">
                    {controls?.NQTFooterSampleInteractiveTasksContent2?.controlText}
                  </a></li>
                  <li><a className="nqt-panel-link" href="https://www.nationsreportcard.gov/science/sample-questions/clear-water/?grade=4"
                    title={controls?.NQTFooterSampleInteractiveTasksTitle?.controlText} target="_blank" rel="noreferrer">
                    {controls?.NQTFooterSampleInteractiveTasksContent3?.controlText}
                  </a></li>
                  <li><a className="nqt-panel-link" href="https://www.nationsreportcard.gov/science/sample-questions/bicycle-materials/?grade=4"
                    title={controls?.NQTFooterSampleInteractiveTasksTitle?.controlText} target="_blank" rel="noreferrer">
                    {controls?.NQTFooterSampleInteractiveTasksContent4?.controlText}
                  </a></li>
                  <li><a className="nqt-panel-link" href="https://enaep.cotw-ng.naep.ed.gov/cotw/Grade4/RED/VH574064"
                    title={controls?.NQTFooterSampleInteractiveTasksTitle?.controlText} target="_blank" rel="noreferrer">
                    {controls?.NQTFooterSampleInteractiveTasksContent5?.controlText}
                  </a></li>
                </ul>
              </NQTFooterPanel>
              <NQTFooterPanel
                title={controls?.NQTFooterSampleQuestSetsPanelTitle?.controlText}
                isActive={accordionOneIsOpen === true}
                onShow={() => { setAccordionOneIsOpen(!accordionOneIsOpen); }}>
                <ul>
                  {/*  Civics Grade 8 2022 */}
                  <li><a className="nqt-panel-link" href="https://enaep.cotw-ng.naep.ed.gov/cotw/Grade8/CIV/blocks/2222CI2W07CLIDXXEX"
                    title={controls?.NQTFooterSampleQuestSetsTitle?.controlText} target="_blank" rel="noreferrer">
                    {controls?.NQTFooterSampleQuestionSetsContent?.controlText}
                  </a></li>
                  {/*  History Grade 8 2022 */}
                  <li><a className="nqt-panel-link" href="https://enaep.cotw-ng.naep.ed.gov/cotw/Grade8/HIS/blocks/2218HI2W08CLIDXXEX"
                    title={controls?.NQTFooterSampleQuestSetsTitle?.controlText} target="_blank" rel="noreferrer">
                    {controls?.NQTFooterSampleQuestionSetsContent3?.controlText}
                  </a></li>
                  {/*  Math Grade 4 2022 (Calculator)*/}
                  <li><a className="nqt-panel-link" href="https://enaep.cotw-ng.naep.ed.gov/cotw/Grade4/MAT/blocks/2222MA1W92CLICXXEX"
                    title={controls?.NQTFooterSampleQuestSetsTitle?.controlText} target="_blank" rel="noreferrer">
                    {controls?.NQTFooterSampleQuestionSetsContent4?.controlText}
                  </a></li>
                  {/*  Math Grade 4 2022 (No Calculator)*/}
                  <li><a className="nqt-panel-link" href="https://enaep.cotw-ng.naep.ed.gov/cotw/Grade4/MAT/blocks/2222MA1W91CLIDXXEX"
                    title={controls?.NQTFooterSampleQuestSetsTitle?.controlText} target="_blank" rel="noreferrer">
                    {controls?.NQTFooterSampleQuestionSetsContent5?.controlText}
                  </a></li>
                  {/*  Math Grade 8 2022 (Calculator)*/}
                  <li><a className="nqt-panel-link" href="https://enaep.cotw-ng.naep.ed.gov/cotw/Grade8/MAT/blocks/2222MA2W92CLICXXEX"
                    title={controls?.NQTFooterSampleQuestSetsTitle?.controlText} target="_blank" rel="noreferrer">
                    {controls?.NQTFooterSampleQuestionSetsContent6?.controlText}
                  </a></li>
                  {/*  Math Grade 8 2022 (No Calculator)*/}
                  <li><a className="nqt-panel-link" href="https://enaep.cotw-ng.naep.ed.gov/cotw/Grade8/MAT/blocks/2222MA2W91CLIDXXEX "
                    title={controls?.NQTFooterSampleQuestSetsTitle?.controlText} target="_blank" rel="noreferrer">
                    {controls?.NQTFooterSampleQuestionSetsContent7?.controlText}
                  </a></li>
                  {/*  Reading Grade 8 2024 - Growing Vertical*/}
                  <li><a className="nqt-panel-link" href="https://enaep.cotw-ng.naep.ed.gov/cotw/Grade8/RED/VH131207"
                    title={controls?.NQTFooterSampleQuestSetsTitle?.controlText} target="_blank" rel="noreferrer">
                    {controls?.NQTFooterSampleQuestionSetsContent12?.controlText}
                  </a></li>
                  {/*  Reading Grade 8 2024 - The Stone in the Road */}
                  <li><a className="nqt-panel-link" href="https://enaep.cotw-ng.naep.ed.gov/cotw/Grade8/RED/VH131065"
                    title={controls?.NQTFooterSampleQuestSetsTitle?.controlText} target="_blank" rel="noreferrer">
                    {controls?.NQTFooterSampleQuestionSetsContent13?.controlText}
                  </a></li>
                </ul>
              </NQTFooterPanel>
              {/* <NQTFooterPanel
                title="Sample Tests [User created]"
                isActive={accordionTwoIsOpen === true}
                onShow={() => { setAccordionTwoIsOpen(!accordionTwoIsOpen); }}>
                <ul>
                  <li>NO LINKS YET</li>
                </ul>
              </NQTFooterPanel> */}

            </div>
            <div className="nqt-content-box">
              <div className="row">
                <div className="col-lg">
                  <div className='nqt-footer-box'>
                    <button className="nqt-footer--link nqt-footer--link-decorated nqt-footer--bold"
                      onClick={() => { setIsTestModalOpen(true); }}>
                      {
                        controls?.FooterResourcesPopQuiz?.controlText
                      }
                    </button>
                    <h3 className='nqt-footer--bold'>{controls?.FooterAccountHeader?.controlText}</h3>
                    <p>{controls?.FooterSigninText?.controlText}<br />
                      <button className="nqt-footer--link nqt-footer--link-decorated nqt-footer--bold nqt-footer-desc"
                        onClick={() => setLoginIsOpen(true)}>
                        {
                          controls?.FooterSigninLink?.controlText
                        }
                      </button>
                    </p>
                    <p>{controls?.FooterCreateAccountText?.controlText}
                      <button className="nqt-footer--link nqt-footer--link-decorated nqt-footer-create-acct"
                        onClick={() => setAccountIsOpen(true)}>
                        {
                          controls?.FooterCreateAccountLink?.controlText
                        }
                      </button></p>
                  </div>
                </div>
                <div className="col-lg">
                  <div className='nqt-footer-box'>
                    <h3 className='middle-column nqt-footer--bold'>{
                      controls?.FooterVideosHeader?.controlText
                    }</h3>

                    <a className="nqt-footer--link nqt-footer--link-decorated" href="https://youtu.be/X09pU9fUHR0"
                      title="How to Search For Geometry Questions" target="_blank" rel="noreferrer">
                      {controls?.FooterVideosSearchGeo?.controlText}
                    </a>

                    <a className="nqt-footer--link nqt-footer--link-decorated" href="https://youtu.be/rm5zY3VWKFU"
                      title="How to Find Math Question Level Data" target="_blank" rel="noreferrer">
                      {controls?.FooterVideosFindMathQLD?.controlText}
                    </a>

                    <a className="nqt-footer--link nqt-footer--link-decorated" href="https://youtu.be/YXoFJNM5hHE"
                      title="How to Download Questions" target="_blank" rel="noreferrer">
                      {controls?.FooterVideosDownload?.controlText}
                    </a>

                    <a className="nqt-footer--link nqt-footer--link-decorated" href="https://youtu.be/gi9FUBfXNcY"
                      title="How to Share Questions List" target="_blank" rel="noreferrer">
                      {controls?.FooterVideosShareQList?.controlText}
                    </a>

                  </div>
                </div>
                <div className="col-lg">
                  <div className='nqt-footer-box'>
                    <a className="nqt-footer--link nqt-footer--link-decorated nqt-footer--bold" href="https://www.nagb.gov/naep/frameworks-overview.html"
                      title="About The Nation's Report Card" target="_blank" rel="noreferrer">
                      {controls?.FooterNAEPHeader?.controlText}
                    </a>
                    <h3 className="nqt-footer--spaced">{controls?.FooterAboutHeader?.controlText}</h3>
                    <button className="nqt-footer--link nqt-footer--link-decorated"
                      onClick={() => setAboutIsOpen(true)}>
                      {
                        controls?.FooterAbout?.controlText
                      }
                    </button>
                    {/* <button className="nqt-footer--link nqt-footer--link-decorated"
                      onClick={() => setAboutNAEPIsOpen(true)}>
                      {
                        controls?.FooterAboutNAEP?.controlText
                      }
                    </button> */}
                    <a className="nqt-footer--link-external nqt-footer--link-decorated" href="https://nces.ed.gov/nationsreportcard/about/"
                      title="About The Nation's Report Card" target="_blank" rel="noreferrer">
                      {controls?.FooterAboutNAEP?.controlText}
                    </a>
                    <button className="nqt-footer--link nqt-footer--link-decorated"
                      onClick={() => { setGoToCopyright(true); setAboutIsOpen(true); }}>
                      {
                        controls?.FooterCopyright?.controlText
                      }
                    </button>
                    <button className="nqt-footer--link nqt-footer--link-decorated"
                      onClick={() => setFAQIsOpen(true)}>
                      {
                        controls?.FooterFAQ?.controlText
                      }
                    </button>
                    <button className="nqt-footer--link nqt-footer--link-decorated"
                      onClick={() => setSystemReqIsOpen(true)}>
                      {
                        controls?.FooterRequirements?.controlText
                      }
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <AboutModal
          goToCopyright={goToCopyright}
          open={aboutIsOpen}
          onClose={() => { goToCopyright && setGoToCopyright(false); setAboutIsOpen(false); }} />
        <SystemRequirementsModal
          open={systemReqIsOpen}
          onClose={() => setSystemReqIsOpen(false)} />
        <AboutNAEPModal
          open={aboutNAEPOpen}
          onClose={() => setAboutNAEPIsOpen(false)}
        />
        <FAQModal
          open={frequentlyAskedQuestionsOpen}
          onClose={() => setFAQIsOpen(false)}
        />
        <ComingSoonModal
          open={comingSoonIsOpen}
          onClose={() => setComingSoonIsOpen(false)}
        />
        <LoginModal open={loginIsOpen} onClose={() => setLoginIsOpen(false)} />
        <AccountModal open={accountIsOpen} onClose={() => setAccountIsOpen(false)} />
        <TestModal
          open={isTestModalOpen}
          onClose={() => { setIsTestModalOpen(false); }}
          subject={null}
          cohort={null} />
      </section>
      {/* {controls?.FooterResourcesPremadeTests?.controlText}
                      {controls?.FooterResourcesVideosSearch?.controlText}
                      {controls?.FooterResourcesVideosFind?.controlText}
                      {controls?.FooterResourcesVideosDownload?.controlText}
                      {controls?.FooterResourcesVideosTest?.controlText}
                      {controls?.FooterResourcesVideosTest?.controlText}
                      {controls?.FooterResourcesVideosAdvanced?.controlText}
                      {controls?.FooterSBTHeader?.controlText}
                      {controls?.FooterSBTReading?.controlText}
                      {controls?.FooterSBTScience?.controlText}
                      {controls?.FooterFWArts?.controlText}
                      {controls?.FooterFWCivics?.controlText}
                      {controls?.FooterFWEconomics?.controlText}
                      {controls?.FooterFWGeography?.controlText}
                      {controls?.FooterFWMath?.controlText}
                      {controls?.FooterFWReading?.controlText}
                      {controls?.FooterFWScience?.controlText}
                      {controls?.FooterFWTEL?.controlText}
                      {controls?.FooterFWScience?.controlText}
                      {controls?.FooterFWHistory?.controlText}
                      {controls?.FooterFWWriting?.controlText} */}
    </>
  );
};

export default NQTFooter;